import axios from "axios"
import { CreateCustomersInterface, GetCustomersInterface } from "@type/customers.types"

const ROOT_PATH = "customers"
export default class CustomersService {
	static createCustomer = (customer: CreateCustomersInterface, company: string) =>
		axios.post<GetCustomersInterface>(ROOT_PATH, { ...customer, company })

	static getAllCustomers = (showAll: boolean) =>
		axios.get<Array<GetCustomersInterface>>(`${ROOT_PATH}`, { params: { showAll } })

	static getCustomerById = (id: string) => axios.get<GetCustomersInterface>(`${ROOT_PATH}/${id}`)

	static updateCustomer = (id: string, customer: Partial<GetCustomersInterface>) =>
		axios.put<GetCustomersInterface>(`${ROOT_PATH}/${id}`, customer)
}
